import React, { useEffect, useRef, useState } from "react";
import * as api from "../../common/athleteCommon/API";
import * as func from "../../common/athleteCommon/FunctionCalls";
import Utils from "../../common/athleteCommon/Utils";
import Select from "react-select";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const Injury = () => {

    const onsetList = [{ onsetId: "1", onsetName: "Sudden" }, { onsetId: "2", onsetName: "Gradual" }, { onsetId: "3", onsetName: "Insidious" }]
    const sympList = [{ sympId: "1", sympName: "Pain" }, { sympId: "2", sympName: "Swelling" }, { sympId: "3", sympName: "Stiffness" }, { sympId: "4", sympName: "Weakness" }, { sympId: "5", sympName: "Instability" }, { sympId: "6", sympName: "Numbness/tingling" }, { sympId: "7", sympName: "Reduced range of motion" }]
    const painList = [{ painId: "1", painName: "Head" }, { painId: "2", painName: "Face" }, { painId: "3", painName: "Cervical spine/neck" }, { painId: "4", painName: "Shoulder" }, { painId: "5", painName: "Upper arm" }, { painId: "6", painName: "Elbow" }, { painId: "7", painName: "Forearm" }, { painId: "8", painName: "Wrist" }, { painId: "9", painName: "Hand/fingers" }, { painId: "10", painName: "Thoracic spine" },
    { painId: "11", painName: "Lumbar spine" }, { painId: "12", painName: "Pelvis" }, { painId: "13", painName: "Hip" }, { painId: "14", painName: "Thigh" }, { painId: "15", painName: "Knee" }, { painId: "16", painName: "Lower leg" }, { painId: "17", painName: "Ankle" }, { painId: "18", painName: "Foot/toes)" }]
    const limitationList = [{ limitId: "1", limitName: "Running" }, { limitId: "2", limitName: "Jumping" }, { limitId: "3", limitName: "Cutting/changing direction" }, { limitId: "4", limitName: "Lifting" }, { limitId: "5", limitName: "Throwing" }]
    const treatmentList = [{ treatId: "1", treatName: "Not started" }, { treatId: "2", treatName: "In treatment" }, { treatId: "3", treatName: "Post-treatment monitoring" }, { treatId: "4", treatName: "Cleared but restricted" }, { treatId: "5", treatName: "Fully cleared" }]
    const concussionSympList = [{ sympId: "1", sympName: "None" }, { sympId: "2", sympName: "Headache" }, { sympId: "3", sympName: "Pressure in head" }, { sympId: "4", sympName: "Balance problems" }, { sympId: "5", sympName: "Dizziness" }, { sympId: "6", sympName: "Nausea" }, { sympId: "7", sympName: "Vision issues" }, { sympId: "8", sympName: "Fatigue" }, { sympId: "9", sympName: "Irritability" }, { sympId: "10", sympName: "Concentration problems" }, { sympId: "11", sympName: "Memory issues" }, { sympId: "12", sympName: "Sleep disturbance" }]

    const [injuryId, setInjuryId] = useState("");
    const [dateOfInjury, setDateOfInjury] = useState("");
    const [onset, setOnset] = useState("");
    const [painLvl, setPainLvl] = useState("");
    const [symptomSummary, setSymptomSummary] = useState("");
    const [symptomType, setSymptomType] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [painLocation, setPainLocation] = useState<any[]>([]);
    const [functionalLimitations, setFunctionalLimitations] = useState<any[]>([]);
    const [treatment, setTreatment] = useState("");
    const [concussionSymp, setConcussionSymp] = useState<any[]>([]);
    const [injuryList, setInjuryList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    // const [onsetList, setOnsetList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [showTable, setShowTable] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        async function fetchInjury() {
            setIsLoading(true);
            const injuryResponse = await func.injury(null);
            setInjuryList(Array.isArray(injuryResponse) ? injuryResponse : []);
            setShowTable(true)
            setIsLoading(false);
        }
        fetchInjury();
    }, [])

    const filteredData = injuryList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const dateRender = (rowData) => {
        return <span>{formatDate(rowData.dateOfInjury)}</span>
    };

    const symptomTypeNameRender = (rowData) => {
        return <span>{rowData.symptomTypeName}</span>
    };

    const painLocationNameRender = (rowData) => {
        return <span>{rowData.painLocationName}</span>
    };

    const functionalLimitationsNameRender = (rowData) => {
        return <span>{rowData.functionalLimitationsName}</span>
    };

    const treatmentNameRender = (rowData) => {
        return <span>{rowData.treatmentName}</span>
    };

    const concussionSpecficNameRender = (rowData) => {
        return <span>{rowData.concussionSpecficSymptomName}</span>
    };

    const injuryStatusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };
    
    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editInjury(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const injId = rowData.injuryId;
        return (
            <Link to="#" onClick={() => deleteInjury(injId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    function newInjury() {
        setIsEdit(false)
        setOpenModal(true)
        setDateOfInjury("");
        setOnset("");
        setPainLvl("");
        setSymptomSummary("");
        setSymptomType([]);
        setPainLocation([]);
        setFunctionalLimitations([]);
        setTreatment("");
        setConcussionSymp([]);
    }

    async function editInjury(rowData: { injuryId: any; }) {
        const injuryId = rowData.injuryId;
        const getDetails = await func.injury(injuryId);
        setDateOfInjury(getDetails.dateOfInjury);
        setFunctionalLimitations(getDetails.functionalLimitations);
        setOnset(getDetails.onset);
        setPainLvl(getDetails.painLevel);
        setSymptomSummary(getDetails.symptomSummary);
        setSymptomType(getDetails.symptomType);
        setPainLocation(getDetails.painLocation);
        setTreatment(getDetails.treatment);
        setConcussionSymp(getDetails.concussionSpecficSymptom);
        setIsEdit(true);
        setOpenModal(true);
    }

    function deleteInjury(injuryId: string) {
        const delteInjury = api.Injury + "/" + injuryId + "/0";
        fetch(delteInjury, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateInjury();
            } else {
                const formData = new FormData();
                formData.append("athleteId", athleteId);
                formData.append("dateOfInjury", dateOfInjury);
                formData.append("onset", onset);
                formData.append("painLevel", painLvl);
                formData.append("symptomSummary", symptomSummary);
                formData.append("symptomType", JSON.stringify(symptomType));
                formData.append("painLocation", JSON.stringify(painLocation));
                formData.append("functionalLimitations", JSON.stringify(functionalLimitations));
                formData.append("treatment", treatment);
                formData.append("concussionSpecficSymptom", JSON.stringify(concussionSymp));
                const createInjury = api.Injury;
                fetch(createInjury, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }

    }

    function updateInjury() {
        const formData = new FormData();
        formData.append("athleteId", athleteId);
        formData.append("dateOfInjury", dateOfInjury);
        formData.append("onset", onset);
        formData.append("painLevel", painLvl);
        formData.append("symptomSummary", symptomSummary);
        formData.append("symptomType", JSON.stringify(symptomType));
        formData.append("painLocation", JSON.stringify(painLocation));
        formData.append("functionalLimitations", JSON.stringify(functionalLimitations));
        formData.append("treatment", treatment);
        formData.append("concussionSpecficSymptom", JSON.stringify(concussionSymp));
        const updateInjury = api.Injury + "/" + injuryId;
        fetch(updateInjury, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Injury</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newInjury() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Injury">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                {showTable && (
                                    <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                )}
                            </div>
                            {(showTable &&
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl &nbsp; No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="dateOfInjury"
                                                    header="Date Of Injury"
                                                    body={dateRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="symptomTypeName"
                                                    header="Symptom Type"
                                                    body={symptomTypeNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="painLocationName"
                                                    header="Pain Location"
                                                    body={painLocationNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="functionalLimitationsName"
                                                    header="Functional Limitations"
                                                    body={functionalLimitationsNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="treatmentName"
                                                    header="Treatment Name"
                                                    body={treatmentNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="concussionSpecficSymptomName"
                                                    header="Concussion Specific Symptom"
                                                    body={concussionSpecficNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="status"
                                                    header="Status"
                                                    body={injuryStatusRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                {currentPermissions.includes("edit") ?
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                    : null
                                                }
                                                {currentPermissions.includes("delete") ?
                                                    <Column
                                                        className="text-link"
                                                        body={deleteDetails}
                                                    ></Column>
                                                    : null
                                                }
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                size="xl"
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Injury</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Date Of Injury</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        required
                                        name="dateOfInjury"
                                        value={dateOfInjury}
                                        onChange={(e) => { setDateOfInjury(e.target.value) }}
                                        placeholder="Enter Date of Injury" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Onset</label>
                                    <Select
                                        value={onsetList.find(onst => onst.onsetId === onset) ? {
                                            value: onset,
                                            label: onsetList.find(onst => onst.onsetId === onset).onsetName
                                        } : null}
                                        onChange={async (e) => {
                                            setOnset(e.value)
                                        }}
                                        styles={customSelect}
                                        required
                                        placeholder="Select Onset"
                                        options={onsetList.map(onst => ({
                                            value: onst.onsetId,
                                            label: onst.onsetName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Pain Level</label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        className="form-control"
                                        name="painlevel"
                                        required
                                        value={painLvl}
                                        onChange={(e) => { setPainLvl(e.target.value) }}
                                        placeholder="Enter Pain level(scale 1-10)" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Symptom Summary</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="sympsumry"
                                        value={symptomSummary}
                                        required
                                        onChange={(e) => { setSymptomSummary(e.target.value) }}
                                        placeholder="Enter Symptom Summary" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Symptom Type</label>
                                    <Select
                                        isMulti
                                        value={Array.isArray(sympList)
                                            ? sympList
                                                .filter(symp => symptomType.includes(symp.sympId))
                                                .map(symp => ({
                                                    value: symp.sympId,
                                                    label: symp.sympName
                                                }))
                                            : []
                                        }
                                        styles={customSelect}
                                        required
                                        onChange={(selectedOptions) => {
                                            // const selectedIds = selectedOptions.map(option => option.value);
                                            const selectedIds = Array.isArray(selectedOptions)
                                                ? selectedOptions.map(option => option.value)
                                                : selectedOptions
                                                    ? [selectedOptions.value]
                                                    : [];
                                            setSymptomType(selectedIds);
                                        }}
                                        options={Array.isArray(sympList)
                                            ? sympList.map(symp => ({
                                                value: symp.sympId,
                                                label: symp.sympName
                                            }))
                                            : []
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Pain Location</label>
                                    <Select
                                        isMulti
                                        value={Array.isArray(painList)
                                            ? painList
                                                .filter(pan => painLocation.includes(pan.painId))
                                                .map(pan => ({
                                                    value: pan.painId,
                                                    label: pan.painName
                                                }))
                                            : []
                                        }
                                        styles={customSelect}
                                        required
                                        onChange={(selectedOptions) => {
                                            // const selectedIds = selectedOptions.map(option => option.value);
                                            const selectedIds = Array.isArray(selectedOptions)
                                                ? selectedOptions.map(option => option.value)
                                                : selectedOptions
                                                    ? [selectedOptions.value]
                                                    : [];
                                            setPainLocation(selectedIds);
                                        }}
                                        options={Array.isArray(painList)
                                            ? painList.map(pan => ({
                                                value: pan.painId,
                                                label: pan.painName
                                            }))
                                            : []
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Functional Limitations</label>
                                    <Select
                                        isMulti
                                        value={Array.isArray(limitationList)
                                            ? limitationList
                                                .filter(limit => functionalLimitations.includes(limit.limitId))
                                                .map(limit => ({
                                                    value: limit.limitId,
                                                    label: limit.limitName
                                                }))
                                            : []
                                        }
                                        styles={customSelect}
                                        required
                                        onChange={(selectedOptions) => {
                                            // const selectedIds = selectedOptions.map(option => option.value);
                                            const selectedIds = Array.isArray(selectedOptions)
                                                ? selectedOptions.map(option => option.value)
                                                : selectedOptions
                                                    ? [selectedOptions.value]
                                                    : [];
                                            setFunctionalLimitations(selectedIds);
                                        }}
                                        options={Array.isArray(limitationList)
                                            ? limitationList.map(limit => ({
                                                value: limit.limitId,
                                                label: limit.limitName
                                            }))
                                            : []
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Treatment</label>
                                    <Select
                                        value={treatmentList.find(treat => treat.treatId === treatment) ? {
                                            value: treatment,
                                            label: treatmentList.find(treat => treat.treatId === treatment)?.treatName
                                        } : null}
                                        onChange={async (e) => {
                                            setTreatment(e.value)
                                        }}
                                        styles={customSelect}
                                        required
                                        placeholder="Select Treatment"
                                        options={treatmentList.map(treat => ({
                                            value: treat.treatId,
                                            label: treat.treatName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Concussion-Specific Symptoms</label>
                                    <Select
                                        isMulti
                                        value={Array.isArray(concussionSympList)
                                            ? concussionSympList
                                                .filter(conc => concussionSymp.includes(conc.sympId))
                                                .map(conc => ({
                                                    value: conc.sympId,
                                                    label: conc.sympName
                                                }))
                                            : []
                                        }
                                        styles={customSelect}
                                        required
                                        onChange={(selectedOptions) => {
                                            // const selectedIds = selectedOptions.map(option => option.value);
                                            const selectedIds = Array.isArray(selectedOptions)
                                                ? selectedOptions.map(option => option.value)
                                                : selectedOptions
                                                    ? [selectedOptions.value]
                                                    : [];
                                            setConcussionSymp(selectedIds);
                                        }}
                                        options={Array.isArray(concussionSympList)
                                            ? concussionSympList.map(conc => ({
                                                value: conc.sympId,
                                                label: conc.sympName
                                            }))
                                            : []
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />{isEdit ? "Update " : "Save "}</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default Injury;